<div *ngIf="show">
  <div
    class="container__notification"
    [ngClass]="{
      'theme__color--error': type === 'error',
      'theme__color--warning': type === 'warning',
      'theme__color--info': type === 'information',
      'theme__color--success': type === 'success',
      'theme__color--message': type === 'message'
    }"
  >
    <div class="container__notification--bar" [ngClass]="{'notification-message-icon': type === 'message' && messageImageSrc }">
      <ng-container *ngIf="type === 'message' && messageImageSrc">
        <img [alt]="messageImageAlt" [src]="messageImageSrc" />
      </ng-container>
    </div>
    <div [ngSwitch]="type" *ngIf="type != 'message'" class="container__notification--icon">
      <i *ngSwitchCase="'warning'" class="fas fa-exclamation-triangle notification__icon--warning"></i>
      <i *ngSwitchCase="'error'" class="fas fa-fw fa-times-circle notification__icon--error"></i>
      <i *ngSwitchCase="'success'" class="fas fa-fw fa-check-circle notification__icon--success"></i>
      <i *ngSwitchCase="'information'" class="fas fa-info-circle notification__icon--info"></i>
    </div>
    <div class="container__notification--body">
      <div class="Body-Small" [ngClass]="{'notification-message': type === 'message' && messageImageSrc }"><ng-content></ng-content></div>
    </div>
    <div *ngIf="dismissable && type !== 'error'" class="container__notification--close" (click)="closeDialog()">
      <i class="far fa-fw fa-times notification__icon--close"></i>
    </div>
  </div>
</div>
